var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "marker",
      class: {
        "ym-highlight-marker": true,
        active: _vm.isActive && _vm.sliderEnabled
      },
      style: _vm.markerStyle(),
      on: { mouseleave: _vm.onBlur }
    },
    [
      _c(
        "figure",
        { style: _vm.figureStyle(), on: { mouseenter: _vm.onFocus } },
        [
          _c("img", {
            style: _vm.iconStyle(),
            attrs: { src: _vm.src, alt: "" }
          })
        ]
      ),
      _vm._v(" "),
      _vm.sliderEnabled
        ? _c(
            "div",
            {
              ref: "slider",
              staticClass: "ym-highlight-slider",
              style: _vm.sliderStyle()
            },
            [
              _c(
                "div",
                {
                  ref: "content",
                  staticClass: "ym-highlight-content",
                  style: _vm.contentStyle()
                },
                [
                  _c("h4", [_vm._v(_vm._s(_vm.headline))]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.content))]),
                  _vm._v(" "),
                  _c("ekomi-stars", {
                    attrs: { id: _vm.ekomiId, mode: "Details", scale: 0.3 }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }